import { Gray, White } from '@constants/color';
import { css } from '@emotion/react';

// TODO: move to global style
export const rootContainer = css({
  display: 'flex',
  flexDirection: 'row'
});

// TODO: move to global style
export const mainContainer = css({
  display: 'flex',
  flexDirection: 'column',
  rowGap: '80px',
  width: '1152px',
  height: '952px',
  padding: '64px'
});
// TODO: move to global style
export const mainTopContainer = css({
  display: 'flex',
  flexDirection: 'column',
  rowGap: '40px'
});

// TODO: move to global style
export const title = css({
  color: White.White10,
  fontSize: '48px',
  fontWeight: 700
});

// TODO: move to global style
export const description = css({});

// TODO: move to global style
export const rightContainer = css({
  display: 'flex',
  flexDirection: 'column',
  rowGap: '36px',
  padding: '180px 64px',
  width: '512px',
  backgroundColor: Gray.Gray90
});
export const rightContainerCenter = css({
  justifyContent: 'center',
  alignItems: 'stretch'
});

export const rightContainerTitle = css({
  color: White.White10,
  fontSize: '32px',
  fontWeight: 700
});
